import { g as t } from "./jsx-runtime.js";
import { ai as s } from "./index2.js";
var o = Object.prototype, n = o.hasOwnProperty;
function e(a, r) {
  return a != null && n.call(a, r);
}
var h = e, p = h, l = s;
function u(a, r) {
  return a != null && l(a, r, p);
}
var f = u;
const v = /* @__PURE__ */ t(f);
export {
  v as n
};
